import React from 'react';
import Modal from '../Modal/Modal';
import cl from './ConfirmModal.module.css';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = "Yes", 
  cancelText = "Cancel",
  icon 
}) => {
  return (
    <Modal size="medium" isOpen={isOpen} onClose={onClose}>
      <div className={cl.modalHead}>
        <h3>
          {icon && <span className={cl.iconHead}>{icon}</span>}
          {title}
        </h3>
      </div>
      <div className={cl.message}>{message}</div>
      <div className={cl.buttons}>
        <button className={cl.cancelBtn} onClick={onClose}>
          {cancelText}
        </button>
        <button className={cl.confirmBtn} onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
